export const CONFIG = {
    SETNRY_ENABLED: import.meta.env.VITE_SENTRY_ENABLED === 'false' ? false : undefined,
};
